<main class="admin-auth-page">
  <section class="admin-panel">
    <a class="brand" routerLink="/admin-login">
      <img class="brand-logo" src="/brand/logo-horizontal.png" alt="ZepBazaar" />
      <strong>Platform Control</strong>
    </a>

    <div class="intro">
      <p>Restricted access</p>
      <h1>Superadmin and developer support login</h1>
    </div>

    @if (resetMessage) {
      <p class="form-success">{{ resetMessage }}</p>
    }

    <form class="auth-form" #adminLoginForm="ngForm" (ngSubmit)="onSubmit()" novalidate>
      <label>
        <span>Email or username</span>
        <input
          name="emailOrUserName"
          autocomplete="username"
          [(ngModel)]="credentials.emailOrUserName"
          placeholder="superadmin or support@zepbazaar.com"
          required
          [disabled]="isSubmitting"
        />
      </label>

      <label>
        <span>Password</span>
        <input
          type="password"
          name="password"
          autocomplete="current-password"
          [(ngModel)]="credentials.password"
          placeholder="Enter admin password"
          required
          [disabled]="isSubmitting"
        />
      </label>

      @if (errorMessage) {
        <p class="form-error">{{ errorMessage }}</p>
      }

      <button class="primary" type="submit" [disabled]="isSubmitting">
        <span class="material-symbols-outlined" aria-hidden="true">
          {{ isSubmitting ? 'progress_activity' : 'admin_panel_settings' }}
        </span>

        {{ isSubmitting ? 'Verifying...' : 'Enter control console' }}
      </button>
    </form>

    <div class="login-switch">
      <a routerLink="/forgot-password" [queryParams]="{ portal: 'admin', email: credentials.emailOrUserName }">Forgot password?</a>
    </div>
  </section>

  <section class="admin-aside" aria-label="Admin access summary">
    <div>
      <p>Platform control</p>
      <h2>Support tenants, review access, and manage operational recovery.</h2>
    </div>

    <div class="support-list">
      <span>
        <strong>Superadmin</strong>
        Full platform administration
      </span>

      <span>
        <strong>Developer support</strong>
        Guided technical support access
      </span>

      <span>
        <strong>Identity API</strong>
        Authenticated via ZepBazaar Identity
      </span>
    </div>
  </section>
</main>
